module.exports = __webpack_public_path__ + "img/logo_cp_white.8995c23e.png";